import axios from "axios";

// Create an Axios instance with default configuration
const apiInstance = axios.create({
   baseURL: "https://api.audley-travel.com",
   // baseURL: "http://localhost:8081/",
   headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
   },
});

// Custom API handler
const API = async (config) => {
   // Destructure the config and provide default values
   const {
      instance = apiInstance,
      method = "get", // Default to GET method if none provided
      url,
      requestConfig = {},
      headers = {},
      requireAuth = false,
   } = config;

   try {
      // Check if authentication is required and add token to headers
      if (requireAuth) {
         const token = localStorage.getItem("authToken");
         if (token) {
            instance.defaults.headers.common["Authorization"] = `Bearer ${token}`;
         } else {
            throw new Error("No token found. Please log in again.");
         }
      }

      // If requestConfig is FormData, update headers
      if (requestConfig instanceof FormData) {
         instance.defaults.headers["Content-Type"] = "multipart/form-data";
      }

      // Update instance headers with any additional headers
      if (headers) {
         Object.assign(instance.defaults.headers, headers);
      }

      // Making the API request based on the method type
      const res = await instance[method.toLowerCase()](url, requestConfig);

      // Check response status and return data if successful
      if (res.status === 200 || res.status === 201) {
         return res.data;
      } else {
         throw new Error(`Unexpected response status: ${res.status}`);
      }
   } catch (e) {
      // Log the error and handle it appropriately
      console.error("API Error:", e.message);
      // Return the error message directly instead of creating a new Error instance
      return e.response?.data || e.message;
   }
};

export default API;
